import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import {
  clearParentDomainCookie,
  ensureGoogleTranslateLoaded,
  isSpanishSelected,
  refreshGoogleTranslateWhenReady,
} from '@/lib/utils/googleTranslate'

/**
 * Angular `index.html` `load` handler + SPA tab parity:
 * initialize Google Translate when Spanish is selected, and re-apply translation
 * after React Router navigations (new tab content is not translated automatically).
 */
export function GoogleTranslateRouteSync() {
  const location = useLocation()
  const isFirstRunRef = useRef(true)
  const tabKey =
    typeof location.state === 'object' && location.state !== null && 'tab' in location.state
      ? String((location.state as { tab?: string }).tab ?? '')
      : ''

  useEffect(() => {
    if (typeof window === 'undefined') return

    clearParentDomainCookie()
    if (isSpanishSelected()) {
      ensureGoogleTranslateLoaded(() => {})
    }
  }, [])

  useEffect(() => {
    if (isFirstRunRef.current) {
      isFirstRunRef.current = false
      if (isSpanishSelected()) {
        refreshGoogleTranslateWhenReady()
      }
      return
    }
    refreshGoogleTranslateWhenReady()
  }, [location.pathname, tabKey, location.key])

  return null
}
